(function () {
  'use strict';
  angular.module('vcuser.vcuser')
    .component('usernew', {
      restrict: 'E',
      bindings: {
        parentsave: '&',
        roles: '<?'
      },
      template: `
      <div class="usernew-component" data-hook="usernew-component">
        <h3>Neuen Benutzer anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addUser()" ng-hide="vm.newuser">Neuen Benutzer anlegen</div>
        <div ng-show="vm.newuser">
          <userform user="vm.newuser" parentsave="vm.saveNewUser(user)" oncancel="vm.cancel()" roles="vm.roles"></userform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Benutzer erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen Benutzers wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Benutzer konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
        <div ng-show="vm.userexists === true" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Benutzer konnte nicht angelegt werden, weil dieser Benutzernamen bereits exisitiert. 
          </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'User', 'Rlog', '$timeout',
        function ($log, User, Rlog, $timeout) {
          let vm = this;
          vm.addUser = addUser;
          vm.saveNewUser = saveNewUser;
          vm.cancel = cancel;


          vm.$onInit = function () {
            if (angular.isUndefined(vm.roles) || !angular.isArray(vm.roles) || vm.roles.length === 0) {
              vm.roles = [{role: 'admin', label: 'Administrator'}, {role: 'user', label: 'Anwender'}];
            }
          };

          function addUser() {
            vm.newuser = {};
            delete vm.created;
            delete vm.canceled;
          }

          function saveNewUser(user) {
            $log.debug('debug: create new user: ', user);
            delete vm.newuser;
            User.$create(user).$then(function (result) {
              vm.created = true;
              reset('created');
              vm.parentsave({user: result});
            }, function (err) {
              $log.debug('error response: ', err.$response.status);
              if (err.$response.status === 403) {
                vm.userexists = true;
              }
              else {
                vm.created = false;
                reset('created');
                $log.error('Creation of new user failed: ', err);
                Rlog.error('vcutils.user', 'usernew', 'Creation of new user failed: ', {
                  user: vm.newuser.username
                });
              }

            });
          }

          function cancel() {
            delete vm.newuser;
            vm.canceled = true;
            reset('canceled');
          }

          function reset(rvar) {
            $timeout(function () {
              delete vm[rvar]
            }, 3500);
          }

        }] // controller
    }); // component

// klammerfriedhof
}());